// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__32aD0","signatureBlock":"Footer_signatureBlock__1HC5l","signature":"Footer_signature__3WkIt"};